import { render, staticRenderFns } from "./person.page.pug?vue&type=template&id=777fd60a&scoped=true&lang=pug&external"
import script from "./person.page.ts?vue&type=script&lang=js&external"
export * from "./person.page.ts?vue&type=script&lang=js&external"
import style0 from "./person.page.sass?vue&type=style&index=0&id=777fd60a&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777fd60a",
  null
  
)

export default component.exports